import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RegionFeatureStatus } from '../../../user-dashboard/shared/region-feature-status.model';

@Component({
  selector: 'app-modal-configuration',
  templateUrl: './location-switcher-wrapper.component.html',
  styleUrls: ['./location-switcher-wrapper.component.scss']
})
export class LocationSwitcherWrapperComponent implements OnInit {

  @Input()
  locationFeature: boolean;

  @Input()
  regionFeature: RegionFeatureStatus;

  @Input()
  titleLabelKey: string;

  @Input()
  secondPartTitleLabelKey: string = undefined;

  @Input()
  subTitleLabelKey: string;

  @Output()
  valueChange = new EventEmitter<boolean>();

  configurationAvailable: boolean;
  configurationDisable: boolean;

  ngOnInit() {
    this.configurationAvailable = this.locationFeature && this.regionFeature !== RegionFeatureStatus.NOT_AVAILABLE;
    this.configurationDisable = this.regionFeature === RegionFeatureStatus.FORCED || this.regionFeature === RegionFeatureStatus.NOT_AVAILABLE;
  }

}
